import { createWebHistory, createRouter } from "vue-router";
import routes from "@/router/routes.js";

const router = createRouter({
  hashbang: false,
  history: createWebHistory(),
  routes: routes,
});

export default router
